{
	"bg": {
		"breadcrumb": {
			"admin": "Админ",
			"home": "Начало",
			"pages": "Страници",
			"articles": "Статии",
			"events": "Събития",
			"calendar": "Календар",
			"media": "Медия",
			"users": "Потребители",
			"profiles": "Профили",
			"contacts": "Контакти",
			"contact": "Контакт",
			"new": "Нов",
			"configure": "Настройки"
		},
		"common": {
			"login": {
				"email": "Потребителско име",
				"password": "Парола"
			},
			"actions": {
				"save": "Запази",
				"cancel": "Отказ",
				"create": "Създай",
				"add": "Добави",
				"actions": "Действия",
				"na": "н/д",
				"copy": "Копирай",
				"copied": "Копирано"
			},
			"titles": {
				"home": "Начална страница",
				"admin": "Администрация"
			}
		},
		"enums": {
			"status": {
				"draft": "Чернова",
				"published": "Публикуван",
				"archived": "Архив",
				"canceled": "Отменен",
				"new": "Нов",
				"read": "Прочетен",
				"active": "Активен",
				"inactive": "Неактивен"
			},
			"reason": {
				"general": "Общо",
				"event": "Запитване за събитие"
			},
			"role": {
				"user": "Потребител",
				"admin": "Админ",
				"editor": "Редактор",
				"organizer": "Организатор",
				"lecturer": "Лектор",
				"performer": "Изпълнител"
			},
			"roles": {
				"organizer": "Организатор",
				"lecturer": "Лектор",
				"performer": "Изпълнител",
				"venue": "Място",
				"community": "Общност",
				"musician": "Музикант",
				"maker": "Мейкър",
				"developer": "Разработчик",
				"graphics artist": "Графичен дизайнер",
				"vibe coder": "Vibe coder"
			},
			"type": {
				"jam-session": "Джем сесия",
				"festival": "Фестивал",
				"performance": "Пърформанс",
				"talks": "Дискусия",
				"conference": "Конференция",
				"lecture": "Лекция",
				"tinkering": "Тинкъринг",
				"workshop": "Уоркшоп",
				"facebook": "Facebook",
				"instagram": "Instagram",
				"soundcloud": "SoundCloud",
				"mixcloud": "Mixcloud",
				"github": "GitHub",
				"bandcamp": "Bandcamp",
				"youtube": "YouTube",
				"website": "Уебсайт",
				"other": "Друго",
				"organizer": "Организатор",
				"lecturer": "Лектор",
				"performer": "Изпълнител",
				"venue": "Място",
				"community": "Общност",
				"musician": "Музикант",
				"maker": "Мейкър",
				"developer": "Разработчик",
				"graphics artist": "Графичен дизайнер",
				"vibe coder": "Vibe coder"
			},
			"source": {
				"upload": "Качване",
				"soundcloud": "SoundCloud",
				"mixcloud": "Mixcloud",
				"youtube": "YouTube",
				"vimeo": "Vimeo",
				"external": "Външен"
			}
		},
		"fields": {
			"_id": "#",
			"fullName": "Име",
			"email": "Имейл",
			"role": "Роля",
			"slug": "Слъг",
			"avatar": "Аватар",
			"about": "За мен",
			"roles": "Роли",
			"status": "Статус",
			"links": "Връзки",
			"tracks": "Парчета",
			"videos": "Видеа",
			"pictures": "Снимки",
			"user": "Потребител",
			"title": "Заглавие",
			"path": "Път",
			"content": "Съдържание",
			"text": "Текст",
			"author": "Автор",
			"categories": "Категории",
			"pinned": "Закачен",
			"type": "Тип",
			"source": "Източник",
			"url": "URL",
			"duration": "Продължителност",
			"startDateTime": "Начало",
			"endDateTime": "Край",
			"poster": "Постер",
			"timezone": "Часова зона",
			"venue": "Място",
			"address": "Адрес",
			"street": "Улица",
			"city": "Град",
			"zip": "ПК",
			"country": "Държава",
			"geo": "Координати",
			"lat": "Географска ширина",
			"lng": "Географска дължина",
			"name": "Име",
			"participants": "Участници",
			"subEvents": "Подсъбития",
			"profile": "Профил",
			"reason": "Повод",
			"event": "Събитие",
			"eventTitle": "Събитие",
			"message": "Съобщение",
			"emailSent": "Имейл изпратен",
			"createdBy": "Създадено от",
			"createdOn": "Създадено на",
			"registerDate": "Регистрация",
			"lastLoginDate": "Последен вход",
			"password": "Парола",
			"passwordConfirm": "Потвърди парола"
		},
		"menu": {
			"front": [
				{
					"page": "home",
					"href": "/",
					"title": "Начало"
				},
				{
					"page": "about",
					"href": "/about",
					"title": "За Нас"
				},
				{
					"page": "calendar",
					"href": "/calendar",
					"title": "Календар"
				},
				{
					"page": "profiles",
					"href": "/profiles",
					"title": "Общност"
				},
				{
					"page": "contact",
					"href": "/contact",
					"title": "Контакт"
				}
			],
			"admin": [
				{
					"page": "admin.home",
					"href": "/admin",
					"title": "Табло"
				},
				{
					"page": "admin.pages",
					"href": "/admin/pages",
					"title": "Страници"
				},
				{
					"page": "admin.articles",
					"href": "/admin/articles",
					"title": "Статии"
				},
				{
					"page": "admin.events",
					"href": "/admin/events",
					"title": "Събития"
				},
				{
					"page": "admin.contacts",
					"href": "/admin/contacts",
					"title": "Контакти"
				},
				{
					"page": "admin.media",
					"href": "/admin/media",
					"title": "Снимки и Видео"
				},
				{
					"page": "admin.users",
					"href": "/admin/users",
					"title": "Потребители"
				},
				{
					"page": "admin.profiles",
					"href": "/admin/profiles",
					"title": "Профили"
				}
			]
		},
		"pages": {
			"about": {
				"title": "За Нас",
				"text": "MusicTechBG е общност около музикалните технологии — синтез, звук, инструменти и споделяне на знания."
			},
			"calendar": {
				"title": "Календар",
				"empty": "Няма публикувани събития засега.",
				"untitled": "Събитие без заглавие",
				"upcoming": "Предстоящи",
				"past": "Минали",
				"rss": "RSS емисия",
				"ics": "Абонирай се в календар (iCal)",
				"addToCalendar": "Добави в календар"
			},
			"contact": {
				"title": "Контакт",
				"intro": "Пишете ни — общи въпроси или относно предстоящо събитие.",
				"name": "Име",
				"email": "Имейл",
				"reason": "Повод",
				"reasonGeneral": "Общо",
				"reasonEvent": "Запитване за събитие",
				"event": "Събитие",
				"eventPlaceholder": "Изберете предстоящо събитие…",
				"eventEmpty": "Няма предстоящи събития",
				"eventEmptyHint": "Няма публикувани предстоящи събития в момента.",
				"message": "Съобщение",
				"send": "Изпрати",
				"sending": "Изпращане…",
				"thanks": "Благодарим — ще се свържем с вас.",
				"error": "Неуспешно изпращане. Опитайте отново.",
				"untitled": "Събитие без заглавие"
			},
			"home": {
				"title": "Добре дошли в MusicTechBG",
				"text": "Добре дошли в страницата на MusicTechBG.\n\nТук ще намерите полезни статии, уроци, връзки на различни теми, свързани с музикалните технологии.\n\nДоста често организираме и събития, на които се събираме и дискутираме интересни новости, някой може да разкаже за последните си дръзновения. Носиме си нови и не толкова нови джаджи и понякога става джем."
			}
		},
		"widget": {
			"addressMap": {
				"title": "Адрес",
				"mapTitle": "Карта",
				"openOsm": "Отвори в OpenStreetMap"
			},
			"eventsCarousel": {
				"cta": {
					"talks": "към лекцията",
					"lecture": "към лекцията",
					"festival": "към фестивала",
					"tinkering": "към Tinkerday",
					"jam-session": "към джема",
					"default": "към събитието"
				},
				"regular": "регулярен",
				"empty": "Няма предстоящи събития засега.",
				"prev": "Предишно",
				"next": "Следващо"
			},
			"pictureList": "Снимки",
			"recentEvents": "Последни събития",
			"trackList": "Тракове",
			"upcomingEvents": "Предстоящи събития",
			"videoList": "Видео"
		}
	},
	"en": {
		"breadcrumb": {
			"admin": "Admin",
			"home": "Home",
			"pages": "Pages",
			"articles": "Articles",
			"events": "Events",
			"calendar": "Calendar",
			"media": "Media",
			"users": "Users",
			"profiles": "Profiles",
			"contacts": "Contacts",
			"contact": "Contact",
			"new": "New",
			"configure": "Configure"
		},
		"common": {
			"login": {
				"email": "Username",
				"password": "Password"
			},
			"actions": {
				"save": "Save",
				"cancel": "Cancel",
				"create": "Create",
				"add": "Add",
				"actions": "Actions",
				"na": "n/a",
				"copy": "Copy",
				"copied": "Copied"
			},
			"titles": {
				"home": "Home page",
				"admin": "Administration"
			}
		},
		"enums": {
			"status": {
				"draft": "Draft",
				"published": "Published",
				"archived": "Archived",
				"canceled": "Canceled",
				"new": "New",
				"read": "Read",
				"active": "Active",
				"inactive": "Inactive"
			},
			"reason": {
				"general": "General",
				"event": "Event enquiry"
			},
			"role": {
				"user": "User",
				"admin": "Admin",
				"editor": "Editor",
				"organizer": "Organizer",
				"lecturer": "Lecturer",
				"performer": "Performer"
			},
			"roles": {
				"organizer": "Organizer",
				"lecturer": "Lecturer",
				"performer": "Performer",
				"venue": "Venue",
				"community": "Community",
				"musician": "Musician",
				"maker": "Maker",
				"developer": "Developer",
				"graphics artist": "Graphics artist",
				"vibe coder": "Vibe coder"
			},
			"type": {
				"jam-session": "Jam session",
				"festival": "Festival",
				"performance": "Performance",
				"talks": "Talks",
				"conference": "Conference",
				"lecture": "Lecture",
				"tinkering": "Tinkering",
				"workshop": "Workshop",
				"facebook": "Facebook",
				"instagram": "Instagram",
				"soundcloud": "SoundCloud",
				"mixcloud": "Mixcloud",
				"github": "GitHub",
				"bandcamp": "Bandcamp",
				"youtube": "YouTube",
				"website": "Website",
				"other": "Other",
				"organizer": "Organizer",
				"lecturer": "Lecturer",
				"performer": "Performer",
				"venue": "Venue",
				"community": "Community",
				"musician": "Musician",
				"maker": "Maker",
				"developer": "Developer",
				"graphics artist": "Graphics artist",
				"vibe coder": "Vibe coder"
			},
			"source": {
				"upload": "Upload",
				"soundcloud": "SoundCloud",
				"mixcloud": "Mixcloud",
				"youtube": "YouTube",
				"vimeo": "Vimeo",
				"external": "External"
			}
		},
		"fields": {
			"_id": "#",
			"fullName": "Full Name",
			"email": "Email",
			"role": "Role",
			"slug": "Slug",
			"avatar": "Avatar",
			"about": "About",
			"roles": "Roles",
			"status": "Status",
			"links": "Links",
			"tracks": "Tracks",
			"videos": "Videos",
			"pictures": "Pictures",
			"user": "User",
			"title": "Title",
			"path": "Path",
			"content": "Content",
			"text": "Text",
			"author": "Author",
			"categories": "Categories",
			"pinned": "Pinned",
			"type": "Type",
			"source": "Source",
			"url": "URL",
			"duration": "Duration",
			"startDateTime": "Start",
			"endDateTime": "End",
			"poster": "Poster",
			"timezone": "Timezone",
			"venue": "Venue",
			"address": "Address",
			"street": "Street",
			"city": "City",
			"zip": "ZIP",
			"country": "Country",
			"geo": "Coordinates",
			"lat": "Latitude",
			"lng": "Longitude",
			"name": "Name",
			"participants": "Participants",
			"subEvents": "Sub-events",
			"profile": "Profile",
			"reason": "Reason",
			"event": "Event",
			"eventTitle": "Event",
			"message": "Message",
			"emailSent": "Email sent",
			"createdBy": "Created By",
			"createdOn": "Created On",
			"registerDate": "Registered",
			"lastLoginDate": "Last Login",
			"password": "Password",
			"passwordConfirm": "Confirm Password"
		},
		"menu": {
			"front": [
				{
					"page": "home",
					"href": "/",
					"title": "Home"
				},
				{
					"page": "about",
					"href": "/about",
					"title": "About"
				},
				{
					"page": "calendar",
					"href": "/calendar",
					"title": "Calendar"
				},
				{
					"page": "profiles",
					"href": "/profiles",
					"title": "Community"
				},
				{
					"page": "contact",
					"href": "/contact",
					"title": "Contact"
				}
			],
			"admin": [
				{
					"page": "admin.home",
					"href": "/admin",
					"title": "Dashboard"
				},
				{
					"page": "admin.pages",
					"href": "/admin/pages",
					"title": "Pages"
				},
				{
					"page": "admin.articles",
					"href": "/admin/articles",
					"title": "Articles"
				},
				{
					"page": "admin.events",
					"href": "/admin/events",
					"title": "Events"
				},
				{
					"page": "admin.contacts",
					"href": "/admin/contacts",
					"title": "Contacts"
				},
				{
					"page": "admin.media",
					"href": "/admin/media",
					"title": "Photos & Video"
				},
				{
					"page": "admin.users",
					"href": "/admin/users",
					"title": "Users"
				},
				{
					"page": "admin.profiles",
					"href": "/admin/profiles",
					"title": "Profiles"
				}
			]
		},
		"pages": {
			"about": {
				"title": "About Us",
				"text": "MusicTechBG is a community around music technology — synthesis, sound, instruments, and sharing knowledge."
			},
			"calendar": {
				"title": "Calendar",
				"empty": "No published events yet.",
				"untitled": "Untitled event",
				"upcoming": "Upcoming",
				"past": "Past",
				"rss": "RSS feed",
				"ics": "Subscribe in calendar (iCal)",
				"addToCalendar": "Add to calendar"
			},
			"contact": {
				"title": "Contact",
				"intro": "Send us a message — general questions or about an upcoming event.",
				"name": "Name",
				"email": "Email",
				"reason": "Reason",
				"reasonGeneral": "General",
				"reasonEvent": "Event enquiry",
				"event": "Event",
				"eventPlaceholder": "Select an upcoming event…",
				"eventEmpty": "No upcoming events",
				"eventEmptyHint": "No published upcoming events right now.",
				"message": "Message",
				"send": "Send",
				"sending": "Sending…",
				"thanks": "Thanks — we will get back to you.",
				"error": "Could not send. Please try again.",
				"untitled": "Untitled event"
			},
			"home": {
				"title": "Welcome to MusicTechBG",
				"text": "Welcome to the MusicTechBG site.\n\nHere you will find useful articles, tutorials, and links on topics related to music technology.\n\nWe often organize events where we meet, discuss interesting news, and share recent experiments. We bring new and not-so-new gadgets, and sometimes it turns into a jam."
			}
		},
		"widget": {
			"addressMap": {
				"title": "Address",
				"mapTitle": "Map",
				"openOsm": "Open in OpenStreetMap"
			},
			"eventsCarousel": {
				"cta": {
					"talks": "to the lecture",
					"lecture": "to the lecture",
					"festival": "to the festival",
					"tinkering": "to Tinkerday",
					"jam-session": "to the jam",
					"default": "to the event"
				},
				"regular": "regular",
				"empty": "No upcoming events yet.",
				"prev": "Previous",
				"next": "Next"
			},
			"pictureList": "Pictures",
			"recentEvents": "Recent events",
			"trackList": "Tracks",
			"upcomingEvents": "Upcoming events",
			"videoList": "Videos"
		}
	}
}
